<template>
  <div class="page" v-wechat-title="$route.meta.title='所有图片'">

    <div class="px-container border-box clearfix">
      <ul v-if="newWaterfallData!=undefined" class="fl px-waterfall border-box clearfix" v-for="(el,ind) in newWaterfallData" :key="ind">
        <li class="border-box" v-for="(item,index) in el" :key="index" @click="seeImg(item.ind)">
          <div class="icon-tx clearfix">
            <img class="img" :src="item.url" alt="" >
          </div>
        </li>
      </ul>
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>
</template>

<script>
  import P400 from '../../components/P400'
  import {pavilionImgs} from "@/service/getData";
  import {wxGetPosition,wxShareme, wxImgPreview } from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore,scollLoadMore} from '@/config/mUtils'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        shopid: this.$route.query.shopid || '',
        bagList:[],//语音列表
        TimeStamp: new Date().getTime(),  //获取当前时间
        imgs: [], //所有图片
        newWaterfallData: '',
        P400: 0, //系统维护中
      }
    },
    computed: {},
    created() {
      this.$loading.show('数据加载中');
      this.initData(this.page);
    },
    methods: {
      //获取语音+景区+推荐信息
      async initData(){
        let res = await pavilionImgs({
          TimeStamp: this.TimeStamp,
          shopid: this.shopid
        });
        if (res.errcode === "00000"){
          this.$loading.hide();
          this.imgs = res.data.imgs;
          if (this.imgs.length > 0) {
            var newWaterfallData = [[],[]];
            this.imgs.forEach((el,i) => {
              var obj = {
                ind: i,
                url: el
              };
              switch( i%2 ) {
              case 0 : newWaterfallData[0].push(obj)
                break
              case 1: newWaterfallData[1].push(obj)
                break
              }
            });
            this.newWaterfallData = [newWaterfallData[0],newWaterfallData[1]];
          }
        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      //图片预览
      seeImg(ind){
        var imgs = this.imgs;
        wxImgPreview(imgs[ind],imgs);
      },
    },
    components: {
      P400,
    },
  }

</script>

<style scoped>
  .page{position: relative; min-height: 100vh; background: #1a1a1a url(../../assets/video-bg2.png) repeat; }
  .px-container { width: 100%; padding: 0 .1rem; }
  .px-waterfall { width: 50%;padding: 0 .1rem;}
  .px-waterfall li{ float: left; margin-top: .2rem;border-radius: .08rem;overflow: hidden;}
  .icon-tx {position:relative;width: 100%;height: auto;}
  .icon-tx img {float: left;height: auto;}

</style>



// WEBPACK FOOTER //
// src/page/view-detail/waterfall-lz.vue